<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllPlan()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                :readonly="
                  (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                    user.warehouseId) || user.role.roleName == 'BRANCH_ADMIN'
                "
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                item-text="label"
                item-value="value"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="typeList"
                label="Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="procurementPlanList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  <v-btn
                    flat
                    icon
                    color="blue lighten-2"
                    @click.stop="onEdit(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
                <td>{{ props.item.issueNo }}</td>
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.planYear }}</td>
                <td>{{ props.item.description }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <procurementPlanExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
      :procurementPlanType="'RAW'"
    ></procurementPlanExcel>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { procurementPlanService } from "../../services/procurement-plan-service";
import { warehouseService } from "../../services/warehouse-service";
import procurementPlanExcel from "./ProcurementPlanExcel.vue";

export default {
  name: "ProcurementPlanList",

  components: { procurementPlanExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Purchasing",
        disabled: true,
      },
      {
        text: "Procurement Plan",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "issueDate",
        sortable: false,
      },
      { text: "Issue No", align: "left", value: "issueNo" },
      { text: "Warehouse", value: "warehouse" },
      { text: "Purchase Type", value: "purchaseType", sortable: false },
      { text: "Plan Year", value: "planYear", sortable: false },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],

    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueNo",
      totalItems: 0,
    },
    buttonLoading: false,
    warehouseList: [],
    procurementPlanList: [],
    openDialog: false,
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    typeList: [
      { label: "ALL", value: "" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      planYear: "",
      type: "",
      warehouseId: "",
      status: "",
      description: "",
      procurementPlanType: "RAW",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getProcurementPlanList();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.roleName == "PROCUREMENT_MANAGER") {
      this.queryParams.warehouseId = this.user.warehouseId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.planYear) {
      this.queryParams.planYear = this.$route.query.planYear;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.procurementPlanType) {
      this.queryParams.procurementPlanType = this.$route.query.procurementPlanType;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAlltypes();

    this.getWarehouseList();
    if(this.user.shop){
      this.queryParams.warehouseId = this.user.shop.warehouseId;
    }
  },
  methods: {
    getAlltypes() {
      procurementPlanService
        .getAllProcurementPlanTypes("RAW")
        .then((res) => {
          let tempList = res.data;
          tempList.forEach((temp) => {
            let tempObj = { label: temp, value: temp };
            this.typeList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "procurement-plans",
        query: this.queryParams,
      });
      this.getProcurementPlanList();
    },
    getProcurementPlanList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      procurementPlanService
        .getProcurementPlanList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.procurementPlanList = res.data.procurementPlanList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/procurement-plan/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getProcurementPlanList();
    },
    exportAllPlan() {
      this.buttonLoading = true;
      procurementPlanService
        .exportProcurementPlanExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    onEdit(procurementPlan) {
      // go to details page
      this.$router.push("/procurement-plan/" + procurementPlan.id);
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
